import { AppointmentEncounterMode } from '@dreryk/egabinet-appointment-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Dropdown, IconFillColor, IconWrapper, MapMarkerIcon, StyledFlex } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';

const t = patientTranslationKeys.encounterMode;

type OnSiteDropdownItemProps = {
   onClick: (appointmentEncounterMode: Extract<AppointmentEncounterMode, 'ON_SITE'>) => Promise<void>;
};

export const OnSiteDropdownItem = (props: OnSiteDropdownItemProps): JSX.Element => {
   return (
      <Dropdown.Item testId={'onSite'} onClick={async (hide) => props.onClick('ON_SITE').finally(hide)}>
         <StyledFlex alignItems={'center'} gap={4}>
            <IconWrapper testId={'onSite'} fillColor={IconFillColor.BACKGROUND}>
               <MapMarkerIcon />
            </IconWrapper>
            <Translate>{t.ON_SITE}</Translate>
         </StyledFlex>
      </Dropdown.Item>
   );
};
